
import type { SystemStyleObject } from "@chakra-ui/theme-tools"


const baseStyle: SystemStyleObject = {
  fontWeight: 'normal',
  fontSize: 'sm',
}

export const FormLabel = {
  baseStyle,
}